// 接入文档：https://cooper.didichuxing.com/docs/document/2200553116152
import { initSign } from '@didi/wsgsig';
initSign({
  env: 'ame',
  bizId: '4b49179f1e18b0980210eef94ec1b094', 
  appVer: '2.0.0',
  os: '4',
});
